export const PAYMENT_MODE_OPTIONS = [
    { label: 'Cash', value: 'CASH' },
    { label: 'Gpay', value: 'GPAY' },
] as const;

// Payment Mode Colors
export const PAYMENT_MODE_COLORS = {
    CASH: 'green',
    GPAY: 'blue',
} as const;

// Transaction Type Options (for form and filters - same labels)
export const TRANSACTION_TYPE_OPTIONS = [
    { label: 'Debit', value: 'DEBIT' },
    { label: 'Credit', value: 'CREDIT' },
] as const;

// Transaction Type Colors
export const TRANSACTION_TYPE_COLORS = {
    DEBIT: 'red',
    CREDIT: 'green',
} as const;

// Payment Type Options (for form and filters - same labels)
export const PAYMENT_TYPE_OPTIONS = [
    { label: 'Patient Invoice', value: 'PATIENT_INVOICE' },
    { label: 'Medical Sales', value: 'MEDICAL_SALES' },
    { label: 'Medical Purchases', value: 'MEDICAL_PURCHASES' },
    { label: 'Clinic Expenses', value: 'CLINIC_EXPENSES' },
    { label: 'Staff Salaries', value: 'STAFF_SALARIES' },
    { label: 'Rent & Utilities', value: 'RENT_UTILITIES' },
    { label: 'Marketing Expenses', value: 'MARKETING_EXPENSES' },
    { label: 'Other Expenses', value: 'OTHER_EXPENSES' },
] as const;

// Payment Type Colors (matching actual payment type values)
export const PAYMENT_TYPE_COLORS = {
    PATIENT_INVOICE: 'blue',
    MEDICAL_SALES: 'green',
    MEDICAL_PURCHASES: 'orange',
    CLINIC_EXPENSES: 'red',
    STAFF_SALARIES: 'purple',
    RENT_UTILITIES: 'cyan',
    MARKETING_EXPENSES: 'magenta',
    OTHER_EXPENSES: 'default',
} as const;

export const PAYMENT_TYPE_FILTER_OPTIONS = PAYMENT_TYPE_OPTIONS;

export const TRANSACTION_TYPE_FILTER_OPTIONS = TRANSACTION_TYPE_OPTIONS;

export const PAYMENT_MODE_FILTER_OPTIONS = PAYMENT_MODE_OPTIONS;

// Payment Mode Types
export type PaymentMode = keyof typeof PAYMENT_MODE_COLORS;

// Transaction Type Types
export type TransactionType = keyof typeof TRANSACTION_TYPE_COLORS;

// Payment Type Types
export type PaymentType = keyof typeof PAYMENT_TYPE_COLORS;
